<div vertical="center" horizontal="between" class="slds-p-right--large ds-header__wrapper">
	<!-- Logotype & Pages Navigation -->
	<div vertical="center">
		<!-- Logotype -->
		<div vertical="center" class="slds-grow slds-p-horizontal--large">
			<!-- Logotype  -->
			<a [routerLink]="[rootRoute]">
				<eff-icon name="eff-logo-white" size="auto" class="ds-h-colors-txt--white ds-header__logotype" />
			</a>
			<!-- / Logotype  -->
		</div>
		<!-- / Logotype -->

		<!--
			Section Switcher — PROJECTED, not rendered here. The switcher exists only where there is
			more than one section to switch between, and that is a property of the build rather than
			of the header: the shell that has the sections projects it, the one without never names
			the component and never ships it.
		-->
		<ng-content select="[headerSections]" />

		<!--
			Pages Navigation — projected for the same reason. The build without the Control Center
			keeps it here, where it has always been; the one with it moves the navigation down a
			level with the sections and projects nothing.
		-->
		<ng-content select="[headerNav]" />
	</div>
	<!-- / Logotype & Pages Navigation -->

	<!--
		Title — projected for the same reason. `PlatformShellComponent` names the open project (or the
		Platform Administrator group) here, centred on the band; `DesignShellComponent` keeps that name in
		the subheader and projects nothing.
	-->
	<ng-content select="[headerTitle]" />

	<div vertical="center" class="slds-shrink-none">
		@if (hasAIAssistantPermission) {
			<ds-assistant class="slds-shrink-none" />
		}

		<!--
			The end slot. `PlatformShellComponent` leaves it empty — its user menu is composed into the
			rail's footer (EFF-26081) — and `DesignShellComponent`, which renders no rail, projects the
			menu here, where it lived before that move.
		-->
		<ng-content select="[headerEnd]" />
	</div>
</div>
